
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/esqueci-minha-senha",
      function () {
        return require("private-next-pages/esqueci-minha-senha/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/esqueci-minha-senha"])
      });
    }
  